module.exports = __webpack_public_path__ + "assets/img/21_62_big.7eb508f0.jpg";